module.exports = __webpack_public_path__ + "img/01.2b35adbf.png";